/*
 * drool-ab-persist.js  (lightweight — runs once, no observers, no per-event work)
 *
 * The A/B app (Visually) hides ONE picker arm per visitor on load —
 * .drool-picker-cards (control) or .drool-picker-stock (variant). Two things can
 * un-hide the wrong arm: the app dropping its own hide on a variant morph, and a
 * full page reload to another PDP (each PDP is a fresh load, and the app re-applies
 * its hide only AFTER paint — so both arms flash briefly).
 *
 * Fix: detect which arm the app hid, write a theme-OWNED <head> rule hiding it, and
 * remember the choice in sessionStorage. A tiny synchronous snippet in <head>
 * (see snippets/scripts.liquid) reads that choice and re-applies the hide BEFORE
 * paint on every subsequent PDP, so there is no duplicate-picker flash. This script
 * then confirms/sets the choice on the first page of the session.
 *
 * Zero ongoing cost: no MutationObserver, no event listeners. The visitor's A/B
 * bucket is stable for the session, so a cached choice is trusted across PDPs.
 */
(function () {
  'use strict';
  if (window.__droolAbPersist) return;
  window.__droolAbPersist = true;

  var KEY = 'drool_ab_arm'; // 'cards' (control hides cards) | 'stock' (variant hides stock)

  function isHidden(el) { return !!el && getComputedStyle(el).display === 'none'; }

  function applyLock(arm) {
    var sel = '.drool-picker-' + arm;
    var s = document.getElementById('drool-ab-lock');
    if (!s) { s = document.createElement('style'); s.id = 'drool-ab-lock'; document.head.appendChild(s); }
    var rule = sel + '{display:none !important}';
    if (s.textContent !== rule) s.textContent = rule;
    try { sessionStorage.setItem(KEY, arm); } catch (e) {}
  }

  // If we already know this session's hidden arm, the <head> snippet has applied it
  // (or will). Trust it — re-applying is idempotent — and do no detection, so our
  // own lock can't fool the detector below.
  var cached;
  try { cached = sessionStorage.getItem(KEY); } catch (e) {}
  if (cached === 'cards' || cached === 'stock') { applyLock(cached); return; }

  // First page of the session: detect which arm the app hid, lock + cache it.
  function tryDetect() {
    var c = document.querySelector('.drool-picker-cards');
    var s = document.querySelector('.drool-picker-stock');
    var ch = isHidden(c), sh = isHidden(s);
    if (ch && !sh) { applyLock('cards'); return true; }
    if (sh && !ch) { applyLock('stock'); return true; }
    return false;
  }

  if (tryDetect()) return;
  var n = 0;
  var iv = setInterval(function () { if (tryDetect() || ++n > 50) clearInterval(iv); }, 150);
})();
